import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface PrioritiesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<PrioritiesServiceData>(db, 'prioritiesService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
